import React, { useState, useEffect, useRef } from 'react';
import { object, func, bool, string } from 'prop-types';
import { ALERT_TYPE, ShowToastMessage, useForm } from '@laramie/ui';
import { CloneObject } from '../../../utils/helpers';
import { isNull } from '../../../utils/validator';
import { useFormErrors } from '../../hooks/useFormErrors';
import { VALIDATION_MESSAGE } from '../../../consts/validationMessage';
import DireccionForm from '../DireccionForm';
import { Accordion, DatePickerCustom, FormError, FormLabel, Modal } from '../../common';

const DomicilioComercioModal = (props) => {

    const direccionInit = {
        id: 0,
        entidad: "DomicilioComercio",
        idEntidad: 0,
        idTipoGeoreferencia: 0,
        idPais: 0,
        idProvincia: 0,
        idLocalidad: 0,
        idZonaGeoreferencia: 0,
        codigoPostal: "",
        calle: "",
        entreCalle1: "",
        entreCalle2: "",
        altura: "",
        piso: "",
        dpto: "",
        referencia: "",
        longitud: 0,
        latitud: 0,
        origen: ""
    }
    const entityInit = {
        id: 0,
        idComercio: 0,
        fechaInicio: null,
        fechaBaja: null,
        direccion: direccionInit
    };

    //hooks
    const [state, setState] = useState({
        entity: entityInit
    });
    const [detalleOpen, setDetalleOpen] = useState(true);

    const [formValues, formHandle, , formSet] = useForm({
        fechaInicio: null,
        fechaBaja: null
    });

    const mount = () => {
        setState(prevState => {
            return {...prevState, entity: props.data.entity};
        });
        formSet({
            fechaInicio: props.data.entity.fechaInicio,
            fechaBaja: props.data.entity.fechaBaja
        });
    }
    useEffect(mount, [props.data.entity]);

    const direccionFormRef = useRef();

    const { errorOf, validate } = useFormErrors(getErrors);

    const isAlta = state.entity.id < 0 || isNull(state.entity.fechaInicio);

    //handles
    const handleClickAceptar = () => {
        if (isFormValid()) {
            let row = CloneObject(state.entity);
            row.fechaInicio = formValues.fechaInicio;
            row.fechaBaja = formValues.fechaBaja;
            row.direccion = direccionFormRef.current.getDataDireccion();

            props.onConfirm(row);
        }
    };

    //funciones
    function getErrors() {

        const errors = {};

        if (formValues.fechaInicio == null) errors.fechaInicio = VALIDATION_MESSAGE.REQUIRED_DATE;

        return errors;
    }

    function isFormValid() {

        if (!validate()) {
            setDetalleOpen(true);
            return false;
        }

        const isValidDireccion = direccionFormRef.current.isValidDireccion();
        if (!isValidDireccion.result) {
            setDetalleOpen(true);
            if (isValidDireccion.message) ShowToastMessage(ALERT_TYPE.ALERT_WARNING, isValidDireccion.message);
            return false;
        }

        return true;
    }

    const getTitle = () => {
        if (!isAlta) {
            const direccion = state.entity.direccion;
            return [direccion.calle, direccion.altura].filter(x => x).join(' ') || direccion.referencia;
        }
        return "Nuevo";
    }

    return (
        <>

            <Modal
                size="xl"
                title={`Domicilio del Comercio: ${getTitle()}`}
                onEscape={() => props.onDismiss()}
                body={(
                            <div className="row">

                                <div className="mb-3 col-12">
                                    <Accordion title="Detalle" keepMounted={true} open={detalleOpen} onToggle={setDetalleOpen}>
                                        <div className='row form-basic'>
                                            <div className="mb-3 col-12 col-md-6 col-lg-3">
                                                <FormLabel htmlFor="fechaInicio" required>Fecha inicio</FormLabel>
                                                <DatePickerCustom
                                                    name="fechaInicio"
                                                    placeholder=""
                                                    className={`form-control ${errorOf('fechaInicio') ? 'is-invalid' : ''}`}
                                                    value={formValues.fechaInicio}
                                                    onChange={formHandle}
                                                    disabled={props.disabled}
                                                />
                                                <FormError message={errorOf('fechaInicio')} />
                                            </div>
                                            <div className="mb-3 col-12 col-md-6 col-lg-3">
                                                <label htmlFor="fechaBaja" className="form-label">Fecha baja</label>
                                                <DatePickerCustom
                                                    name="fechaBaja"
                                                    placeholder=""
                                                    className="form-control"
                                                    value={formValues.fechaBaja}
                                                    minValue={formValues.fechaInicio}
                                                    onChange={formHandle}
                                                    disabled={props.disabled}
                                                />
                                                <FormError />
                                            </div>
                                        </div>
                                        <div className='row form-basic'>
                                            <DireccionForm
                                                ref={direccionFormRef}
                                                data={{
                                                    entity: state.entity.direccion
                                                }}
                                                disabled={props.disabled}
                                                initFormEdit={(isAlta && state.entity.direccion.latitud === 0 && state.entity.direccion.longitud === 0)}
                                            />
                                        </div>
                                    </Accordion>
                                </div>

                            </div>
                )}
                footer={!props.disabled ? (<>
                                <button className="btn btn-outline-primary" data-dismiss="modal"
                                        onClick={(event) => props.onDismiss()}>Cancelar
                                </button>
                                <button className="btn btn-primary" data-dismiss="modal"
                                        onClick={(event) => handleClickAceptar()}>Aceptar
                                </button>
                </>) : (
                                <button className="btn back-button" data-dismiss="modal"
                                        onClick={(event) => props.onDismiss()}>Volver
                                </button>
                )}
                footerClassName={props.disabled ? 'f-align' : ''}
            />

        </>
    );
}

DomicilioComercioModal.propTypes = {
    processKey: string.isRequired,
    disabled: bool,
    data: object.isRequired,
    onConfirm: func.isRequired,
    onDismiss: func.isRequired
};

DomicilioComercioModal.defaultProps = {
    disabled: false
};

export default DomicilioComercioModal;
